import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { JsonLd } from 'react-schemaorg';

/** See https://schema.org/WebPage */
import { jsx as _jsx } from "react/jsx-runtime";
export const WebPageStructuredData = props => {
  const {
    title,
    description,
    canonicalUrl,
    image,
    additionalProperty
  } = props;
  const webPage = _objectSpread(_objectSpread(_objectSpread({
    '@context': 'https://schema.org/',
    '@type': 'WebPage',
    name: title,
    description
  }, canonicalUrl ? {
    url: canonicalUrl
  } : {}), image ? {
    image
  } : {}), additionalProperty && additionalProperty.length > 0 ? {
    additionalProperty
  } : {});
  return /*#__PURE__*/_jsx(JsonLd, {
    item: webPage
  });
};